<template>
    <div class="swatch-compare">
		<div class="compare-color compare-new" :style="newColorStyle"></div>
		<div class="compare-color compare-old" :style="oldColorStyle"></div>
    </div>
</template>

<script>
    import {backgroundCSS} from "../../../../../Lib/helpers/cssOutput";
    import ActivePalette   from "../../../Store/ActivePalette";
    import DraftSwatch     from "../../../Store/DraftSwatch";

    export default {
        name: "ColorPreview",
        computed: {
            oldColorStyle() {
                let activeSwatch = this.activePalette.getActiveSwatch();
                if(activeSwatch.color) {
                    return backgroundCSS(activeSwatch.color);
                }
            },
            newColorStyle() {
                let draft = this.draft.rgb();
                if(draft) {
                    return backgroundCSS(this.draft.rgb());
                }
            },
        },
        data() {
            return {
                activePalette: new ActivePalette(),
                draft: new DraftSwatch(),
            }
        }
    }
</script>